import type { QuotaPressureLevel } from '@/lib/quota/deriveQuotaPressure';

/**
 * Bar colour for a usage meter at a given pressure level. `undefined` keeps
 * the default primary fill, so an unpressured bar renders exactly as before.
 */
export function quotaLevelBarClass(
  level: QuotaPressureLevel | null,
): string | undefined {
  if (level === 'exhausted') return 'bg-orange-500';
  if (level === 'approaching') return 'bg-amber-500';
  return undefined;
}
